import * as actions from './billingLandingConstants';
import getClient from 'api';
import {
  INTERNAL_SERVER_ERROR_CODE,
  LOCATION_SITE_LIST_PATH,
  NO_INVOICE_MESSAGE,
} from 'constant';

const client = getClient();

export const addActiveLocation = payload => ({
  type: actions.ADD_BILL_TO_SITE_NUMBER,
  payload,
});

export const addLocationList = payload => ({
  type: actions.ADD_LOCATION_LIST,
  payload,
});

export const startAddLocationList = () => {
  return dispatch => {
    dispatch(startLoading);

    return client
      .get(LOCATION_SITE_LIST_PATH)
      .then(response => {
        dispatch(addLocationList(response.data));
        dispatch(stopLoading());
      })
      .catch(error => {
        dispatch(addCustomError(error.response?.data?.message));
        dispatch(addGlobalError(error));
        dispatch(stopLoading());
      });
  };
};

//ADD_NEXT_INVOICE
export const addNextInvoice = payload => ({
  type: actions.ADD_NEXT_INVOICE,
  payload,
});

export const startAddNextInvoice = billToSiteNumber => {
  return dispatch => {
    dispatch(startLoading);
    return client
      .get(
        `/api/platform-billing-orchestration/invoice/next?billToSiteNumber=${billToSiteNumber}`
      )
      .then(response => {
        dispatch(addNextInvoice(response.data));
        dispatch(stopLoading());
      })
      .catch(error => {
        error?.response?.status === INTERNAL_SERVER_ERROR_CODE
          ? dispatch(addCustomError(NO_INVOICE_MESSAGE))
          : dispatch(addGlobalError(error));

        dispatch(stopLoading());
      });
  };
};

/**
 * Clear next invoice date data
 */
export const clearNextInvoiceDate = () => ({
  type: actions.CLEAR_NEXT_INVOICE,
});

//ADD_GLOBAL_ERROR
export const addGlobalError = payload => ({
  type: actions.ADD_GLOBAL_ERROR,
  payload,
});

//CLEAR_GLOBAL_ERROR
export const clearGlobalError = () => ({
  type: actions.CLEAR_GLOBAL_ERROR,
});

//ADD_NEXT_INVOICE
export const setHeaderTooltipText = payload => ({
  type: actions.SET_HEADER_TOOLTIP_TEXT,
  payload,
});

//TOGGLE_CARD_DRAWER
export const toggleAddPaymentDrawer = () => ({
  type: actions.TOGGLE_CARD_DRAWER,
});

//TOGGLE_PAYMENT_DRAWER
export const togglePaymentDrawer = () => ({
  type: actions.TOGGLE_PAYMENT_DRAWER,
});

//START_LOADING
export const startLoading = () => ({
  type: actions.START_LOADING,
});

//STOP_LOADING
export const stopLoading = () => ({
  type: actions.STOP_LOADING,
});

//ADD_GLOBAL_WARNING
export const addGlobalWarning = payload => ({
  type: actions.ADD_GLOBAL_WARNING,
  payload,
});

//CLEAR_GLOBAL_WARNING
export const clearGlobalWarning = () => ({
  type: actions.CLEAR_GLOBAL_WARNING,
});

/**
 * Sets the summary page flag in the application state.
 *
 * @param {boolean} payload - Flag indicating if summary page is active
 * @returns Redux action with type and payload
 */
export const setSummaryPageFlag = payload => ({
  type: actions.SET_SUMMARY_PAGE_FLAG,
  payload,
});

export const addCustomError = payload => ({
  type: actions.ADD_CUSTOM_ERROR,
  payload,
});

export const clearCustomError = () => ({
  type: actions.CLEAR_CUSTOM_ERROR,
});

export const addAlertDetails = payload => ({
  type: actions.ADD_ALERT_DETAILS,
  payload,
});

export const clearAlertDetails = () => ({
  type: actions.CLEAR_ALERT_DETAILS,
});

/**
 * Clear default/custom error, warning and any other alert type
 */
export const clearAlerts = () => dispatch => {
  dispatch(clearGlobalError());
  dispatch(clearGlobalWarning());
  dispatch(clearCustomError());
  dispatch(clearAlertDetails());
};
